// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7bb475f2","732":"fd147eb4","977":"c2b8a58d"}[chunkId] + ".chunk.js";
};